export default (url) => {
  window.location.assign(url);
};
